import type { OrderType } from 'apiConnector/blotters';

export function secondaryMarketOpenTabFromTradeAllocationRequested(formType: OrderType, bcsKey: string, isin: string) {
  return {
    type: 'SECONDARY_MARKET_OPEN_TAB_FROM_TRADE_ALLOCATION_REQUESTED' as const,
    formType,
    bcsKey,
    isin,
  };
}

export type SecondaryMarketOpenTabFromTradeAllocationRequested = ReturnType<
  typeof secondaryMarketOpenTabFromTradeAllocationRequested
>;

export type SecondaryMarketOpenTabFromTradeAllocationActions = SecondaryMarketOpenTabFromTradeAllocationRequested;
